<template>
  <div class="bg-s-50" data-testid="futures-page">
    <FuturesHeader
      title="Trade Cobalt Futures on ICE with Benchmark Mineral Intelligence (BMI)"
      description="Regulated Cobalt hydroxide Prices for the Battery Metals Market"
    />

    <AboutBMIAndICE>
      <p>
        Benchmark Mineral Intelligence (BMI) and Intercontinental Exchange (ICE)
        offer the industry’s most accurate cobalt hydroxide futures contract - a
        trusted tool for battery industry participants worldwide.
      </p>
      <p>
        Used across the physical battery supply chain, BMI cobalt prices are
        regulated, transparent, and relied upon to settle real-world contracts
        with accuracy and confidence.
      </p>
    </AboutBMIAndICE>

    <TradeableFutures
      image-url="https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1744123687/assets/ice/ice-cobalt/4e37103e0e2ae46a476813e8b37a93f9_wrndzv.png"
      legend="This contract is based on Benchmark Mineral Intelligence’s trusted price assessments—recognized globally for precision and credibility."
    >
      <ul>
        <li> Cobalt Hydroxide CIF Asia (BMI) Future </li>
      </ul>
    </TradeableFutures>

    <ContactSection>
      <p>
        Want to understand how cobalt futures work or integrate BMI prices into
        your trading strategy?
      </p>
      <p>
        Get in touch with our experts for free guidance and a product demo.
      </p>
    </ContactSection>

    <WhyTradeBMI
      title="Why Trade BMI Cobalt Futures?"
      feature01="Trusted by battery and EV supply chain leaders"
      feature02="Enables physical contract settlement"
      feature03="Transparent, regulated cobalt pricing"
      feature04="Developed by pioneers in battery metals benchmarking"
    />

    <NewsletterMarketFormSection
      v-if="showNewsletterForm"
      image="https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto/v1744123693/assets/ice/ice-cobalt/ec62594bf4547dd12d8b5ffee6e6b472_cgcfdo.png"
      title="Looking for key market updates? Sign up to our free Newsletter."
      :form-id="config.public.hubspotCobaltICENewsletterFormId"
      image-extra-classes="bg-center"
      with-overlay
    />
  </div>
</template>

<script lang="ts" setup>
import FuturesHeader from '~/components/futures-markets/Header.vue'
import AboutBMIAndICE from '~/components/futures-markets/AboutBMIAndICE.vue'
import TradeableFutures from '~/components/futures-markets/TradeableFutures.vue'
import ContactSection from '~/components/futures-markets/ContactSection.vue'
import WhyTradeBMI from '~/components/futures-markets/WhyTradeBMI.vue'
import NewsletterMarketFormSection from '~/components/unauth-market/NewsletterMarketFormSection.vue'

import { useSeo } from '~/composables/useSeo'
import { useUserEmailPreferences } from '~/composables/useUserEmailPreferences'

const config = useRuntimeConfig()

const { hasBenchmarkNewsletter } = useUserEmailPreferences()
const showNewsletterForm = computed(() => !hasBenchmarkNewsletter.value)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Trade Cobalt Futures on ICE | Benchmark Cobalt Prices',
  description:
    'Trade cobalt hydroxide futures on ICE with Benchmark Mineral Intelligence. Trusted, regulated cobalt pricing for the battery metals market. Join the community.',
})
useHead(seo)
</script>
